<template>
  <div class="c-app page" :class="{ 'c-dark-theme': darkMode }">
    <Sidebar />
    <CWrapper>
      <Header />
        <div class="c-body">
            <main class="c-main p-0 position-relative">
                <transition name="fade">
                    <CElementCover
                        :style="{
                            'z-index':1,
                            'background-color':'#f6f6f6'
                        }"
                        :boundaries="[{ sides: ['top', 'left'], query: '.media-body' }]"
                        :opacity="1"
                        v-show="pageLoadingStore"
                    >
                        <CSpinner 
                            size="5xl" 
                            color="primary"
                            :style="{
                                width: '3rem',
                                height: '3rem'

                            }"
                        />
                    </CElementCover>
                </transition>
                <child/>
            </main>
        </div>
      <Footer />
    </CWrapper>
  </div>
</template>

<script>
import Sidebar from "~/components/Admin/Sidebar";
import Header from "£lement/header";
import Footer from "£lement/footer";
import { mapGetters } from "vuex";
export default {
    name: "AdminLayout",

    components: {
        Sidebar,
        Header,
        Footer,
    },

    computed: {
        ...mapGetters({
            darkMode: "panel/darkMode",
            check_commercial:"auth/check_commercial",
            pageLoadingStore: "page/loading",
            storeLangLocale: "lang/locale",
        })
    },
    data () {
        return {
            fixedToasts: 0,
        }
    },
    watch:{
        storeLangLocale(newValue, oldValue){
            if(newValue != oldValue){
                this.$i18n.locale = newValue;
            }
        }
    },
};
</script>
<style scoped lang="scss">
    .container-fluid{
        padding: 0;
    }
</style>